<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">人次统计</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body"  style="max-height: 300px;padding: 10px;">


        <div style="text-align: center;padding: 10px;">人次：{{askAnswerRecordSiteDTO.sort}}</div>

        <div v-for="(value,i) in tableData" :key="i" style="padding: 10px">
          <div>标题：{{value.askAnswerGroupName}}</div>
          <div>回答：{{value.askAnswerItemName}}</div>
        </div>


      </div>
      <!--      <div class="modal-footer">-->
      <!--        <el-button @click.native="closeSelf">取消</el-button>-->
      <!--        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>-->
      <!--      </div>-->
    </div>

  </div>
</template>


<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Add',
  props: [],
  data() {
    return {

      loading: false,

      askAnswerRecordSiteDTO:null,
      tableData:[],

    }
  },
  methods: {
    init(askAnswerRecordCode){

      this.getTotal(askAnswerRecordCode);

    },
    closeSelf() {
      this.$emit("closeSub");
    },

    getTotal(code){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'AskAnswerRecordSite/Get',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          askAnswerRecordSiteCode: code,
        }

      }).then( (response)=> {
        if(response.data.error == 0){

          this.askAnswerRecordSiteDTO = response.data.data.askAnswerRecordSiteDTO;
          this.tableData = response.data.data.askAnswerRecordSiteDTO.listAskAnswerRecordSiteItemDTO;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>


